import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { User } from '@/types';

type UsersState = Record<User['uid'], User>

const initialState: UsersState = {};

export const fetchUsers = createAsyncThunk("users/fetchUsers", async (users: string[], { getState }) => {
  try {
    const fetchedUsers: UsersState= {};
    const state = getState() as UsersState;

    for await (const userId of users) {
      if (!state[userId]) {
        const docRef = doc(db, `users/${userId}`);
        const querySnapshot = await getDoc(docRef);

        const newUser: User = {
          ...querySnapshot.data() as User,
          uid: querySnapshot.id,
        }

        fetchedUsers[newUser.uid] = newUser;
      }
    }

    return fetchedUsers;
  } catch (error) {
    console.error(error);
  }
});

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<User>) => {
      const isUserIncluded = state[action.payload.uid];

      if (isUserIncluded) {
        return state;
      }

      return {
        ...state,
        [action.payload.uid]: action.payload
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.fulfilled, (state, action: PayloadAction<Record<string, User> | undefined>) => {
      return {
        ...state,
        ...action.payload
      }
    });
  }
});

export const {
  addUser
} = usersSlice.actions;

export default usersSlice.reducer;
